module.exports = __webpack_public_path__ + "static/media/AG.d534b965.png";